<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.convenioMedico"
        ref="DataTable"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'cadastro-convenio-medico-edit', params: { id: item.id } })"
                authorize="update-cadastro-convenio-medico"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                authorize="destroy-cadastro-convenio-medico"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

export default {
    created() {

        this.repositories.convenioMedico = this.getConectaSusRepository('cadastro.sujeitoAtencao.convenioMedico')
    },
    data: () => ({
        fields: [
            {
                name: 'nome',
                key: 'nome',
                label: 'Nome',
                searchable: true,
                sortable: true
            },
            {
                name: 'actions',
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
        repositories: {
            convenioMedico: null,
        },
    }),
    methods: {
        handleDestroy({ id }) {

            const destroy = () => this.repositories.convenioMedico.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o convênio médico?', destroy, this.handleError)
        },
    },
    mixins: [ repository, error ],
}
</script>